import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AuthCode from "../../types/auth-code";
import { ActiveTab } from "./active-tab";
import Alert from "./alert";

interface IForgotTabProps {
  alert: boolean;
  customerType: string;
  username: string;
  setUsername: (username: string) => void;
  setActiveTab: (activeTab: ActiveTab) => void;
  handleContinue: (e: AuthCode) => void;
  toggle: boolean;
  handleToggle: () => void;
}

const ForgotTab: FunctionComponent<IForgotTabProps> = ({
  alert,
  customerType,
  username,
  setUsername,
  setActiveTab,
  handleContinue,
  toggle,
  handleToggle,
}) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AuthCode>();

  return (
    <>
      <div className="signup-form-head-section mb-10 flex-col-reverse flex">
        <h3 className="head-title pt-4">{t("ForgotPassword.Title")}</h3>
        <span className="sepanta-icon-keylock icon-box"></span>
      </div>

      {alert ? <Alert color="red" message={t("ForgotPassword.Error")} /> : null}

      <form onSubmit={handleSubmit(handleContinue)}>
        <div className="form-section rtl flex flex-grow flex-col gap-4 mb-0 pb-5">
          <div
            style={{ display: "flex" }}
            className="form-group flex flex-col w-full rtl text-right mt-6 relative"
          >
            <input
              maxLength={12}
              {...register("username")}
              type="hidden"
              value={username}
              className="form-control form-control-lg pl-4 shadow-none"
            />
            <label htmlFor="forgot-username" className="pr-4">
              {t(`Login.Username.${customerType}.Label`)} *
            </label>
            <input
              id="forgot-username"
              maxLength={12}
              {...register("username")}
              value={username}
              onChange={(e) => {
                register("username").onChange(e);
                setUsername(e.target.value);
              }}
              type="phone"
              className="border-2 p-4 rounded-lg mt-2 text-left tracking-wider"
              placeholder={t(`Login.Username.${customerType}.PlaceHolder`)}
            />
            <p className="absolute left-0 text-red-500">
              {errors.username?.message}
            </p>
            <span className="sepanta-icon-mobile absolute top-12 left-2 icon-orange"></span>
          </div>
        </div>

        {toggle && (
          <div className="flex items-center justify-start flex-row-reverse">
            <input
              className="mr-5"
              id="lbp_checkbox"
              type="checkbox"
              checked={!toggle}
              onChange={handleToggle}
            />
            <label
              htmlFor="lbp_checkbox"
              className="ml-2 text-sm font-normal text-gray-900 pr-2"
            >
              {t("Login.WithPass")}
            </label>
          </div>
        )}

        <div className="form-section rtl flex flex-col gap-4 justify-between pb-10">
          <button
            type="submit"
            className="signup-btn p-5 flex text-center justify-center rounded-xl"
          >
            {t("ForgotPassword.Continue")}
            <span className="sepanta-icon-left-long-arrow"></span>
          </button>

          {!toggle && (
            <button
              type="button"
              onClick={() => setActiveTab("login")}
              className="flex items-center justify-center navigate-link-bd"
            >
              {t("ForgotPassword.ToLogin")}
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default ForgotTab;
